<template>
  <v-dialog
    persistent
    v-model="dialog"
    width="500px"
    height="200px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @click:outside="() => {}"
  >
    <v-card>
      <v-card-title>Báo cáo đã được đối soát</v-card-title>
      <v-card-text>
        <div style="margin-bottom: 10px">
          Hệ thống phát hiện báo cáo ứng với mã chuyển khoản này đã được đối soát. Để tiếp tục hãy chọn
          <span style="font-weight: 600">ghi đè</span>, <span style="font-weight: 600">cộng dồn</span> hoặc
          <span style="font-weight: 600">bỏ qua</span> đối với mã đối soát này
        </div>
        <div>Số tiền: {{ data.amountMoney.toLocaleString('en-US') }}</div>
        <div>Nội dung: {{ data.reference }}</div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" color="primary" outlined light @click="clickAction1">Bỏ qua</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" color="primary" outlined light @click="clickAction2">Ghi đè</v-btn>
        <v-btn color="primary" width="100px" class="elevation-0" @click="clickAction3">Cộng dồn</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return { dialog: false, title: '', data: {}, text: '', action1: () => {}, action2: () => {}, action3: () => {} }
  },
  methods: {
    show({ data = {}, action1 = () => {}, action2 = () => {}, action3 = () => {} }) {
      this.dialog = true
      this.data = data
      this.action1 = action1
      this.action2 = action2
      this.action3 = action3
    },
    clickAction1() {
      this.action1()
      this.dialog = false
    },
    clickAction2() {
      this.action2()
      this.dialog = false
    },
    clickAction3() {
      this.action3()
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
</style>
